const abi = [
  {
    inputs: [],
    name: 'InvalidSqrtRatio',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidTick',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'contract IUniswapV3Pool',
        name: 'pool',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'lowPercent',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'upPercent',
        type: 'uint256',
      },
    ],
    name: 'calculateWeightAmountsPerUnitLiquidity',
    outputs: [
      {
        internalType: 'uint256',
        name: 'amount0',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'amount1',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'address',
            name: 'positionManager',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'tokenId',
            type: 'uint256',
          },
        ],
        internalType: 'struct IV3LiquidityHelper.PositionManagerInput[]',
        name: 'input',
        type: 'tuple[]',
      },
    ],
    name: 'positionManagerInfo',
    outputs: [
      {
        components: [
          {
            internalType: 'address',
            name: 'token0',
            type: 'address',
          },
          {
            internalType: 'address',
            name: 'token1',
            type: 'address',
          },
          {
            internalType: 'uint24',
            name: 'fee',
            type: 'uint24',
          },
          {
            internalType: 'address',
            name: 'pool',
            type: 'address',
          },
          {
            internalType: 'address',
            name: 'owner',
            type: 'address',
          },
          {
            internalType: 'int24',
            name: 'tickLower',
            type: 'int24',
          },
          {
            internalType: 'int24',
            name: 'tickUpper',
            type: 'int24',
          },
          {
            internalType: 'uint128',
            name: 'liquidity',
            type: 'uint128',
          },
          {
            internalType: 'uint128',
            name: 'unclaimedFee0',
            type: 'uint128',
          },
          {
            internalType: 'uint128',
            name: 'unclaimedFee1',
            type: 'uint128',
          },
          {
            internalType: 'uint128',
            name: 'owed0',
            type: 'uint128',
          },
          {
            internalType: 'uint128',
            name: 'owed1',
            type: 'uint128',
          },
          {
            internalType: 'uint256',
            name: 'amount0',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'amount1',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'lowPrice',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'upPrice',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'currentPrice',
            type: 'uint256',
          },
          {
            internalType: 'bool',
            name: 'tickIn',
            type: 'bool',
          },
        ],
        internalType: 'struct IV3LiquidityHelper.PositionInfo[]',
        name: 'output',
        type: 'tuple[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'address',
            name: 'positionManager',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'tokenId',
            type: 'uint256',
          },
        ],
        internalType: 'struct IV3LiquidityHelper.PositionManagerInput[]',
        name: 'input',
        type: 'tuple[]',
      },
    ],
    name: 'positionManagerInfoLight',
    outputs: [
      {
        components: [
          {
            internalType: 'address',
            name: 'token0',
            type: 'address',
          },
          {
            internalType: 'address',
            name: 'token1',
            type: 'address',
          },
          {
            internalType: 'address',
            name: 'pool',
            type: 'address',
          },
          {
            internalType: 'uint128',
            name: 'liquidity',
            type: 'uint128',
          },
          {
            internalType: 'uint128',
            name: 'owed0',
            type: 'uint128',
          },
          {
            internalType: 'uint128',
            name: 'owed1',
            type: 'uint128',
          },
          {
            internalType: 'uint256',
            name: 'amount0',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'amount1',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'lowPrice',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'upPrice',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'currentPrice',
            type: 'uint256',
          },
          {
            internalType: 'bool',
            name: 'tickIn',
            type: 'bool',
          },
        ],
        internalType: 'struct IV3LiquidityHelper.PositionInfoLight[]',
        name: 'output',
        type: 'tuple[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'address',
            name: 'pool',
            type: 'address',
          },
          {
            internalType: 'address',
            name: 'owner',
            type: 'address',
          },
          {
            internalType: 'int24',
            name: 'tickLower',
            type: 'int24',
          },
          {
            internalType: 'int24',
            name: 'tickUpper',
            type: 'int24',
          },
        ],
        internalType: 'struct IV3LiquidityHelper.PositionPoolInput[]',
        name: 'input',
        type: 'tuple[]',
      },
    ],
    name: 'positionPoolInfo',
    outputs: [
      {
        components: [
          {
            internalType: 'address',
            name: 'token0',
            type: 'address',
          },
          {
            internalType: 'address',
            name: 'token1',
            type: 'address',
          },
          {
            internalType: 'uint24',
            name: 'fee',
            type: 'uint24',
          },
          {
            internalType: 'address',
            name: 'pool',
            type: 'address',
          },
          {
            internalType: 'address',
            name: 'owner',
            type: 'address',
          },
          {
            internalType: 'int24',
            name: 'tickLower',
            type: 'int24',
          },
          {
            internalType: 'int24',
            name: 'tickUpper',
            type: 'int24',
          },
          {
            internalType: 'uint128',
            name: 'liquidity',
            type: 'uint128',
          },
          {
            internalType: 'uint128',
            name: 'unclaimedFee0',
            type: 'uint128',
          },
          {
            internalType: 'uint128',
            name: 'unclaimedFee1',
            type: 'uint128',
          },
          {
            internalType: 'uint128',
            name: 'owed0',
            type: 'uint128',
          },
          {
            internalType: 'uint128',
            name: 'owed1',
            type: 'uint128',
          },
          {
            internalType: 'uint256',
            name: 'amount0',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'amount1',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'lowPrice',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'upPrice',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'currentPrice',
            type: 'uint256',
          },
          {
            internalType: 'bool',
            name: 'tickIn',
            type: 'bool',
          },
        ],
        internalType: 'struct IV3LiquidityHelper.PositionInfo[]',
        name: 'output',
        type: 'tuple[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'address',
            name: 'pool',
            type: 'address',
          },
          {
            internalType: 'address',
            name: 'owner',
            type: 'address',
          },
          {
            internalType: 'int24',
            name: 'tickLower',
            type: 'int24',
          },
          {
            internalType: 'int24',
            name: 'tickUpper',
            type: 'int24',
          },
        ],
        internalType: 'struct IV3LiquidityHelper.PositionPoolInput[]',
        name: 'input',
        type: 'tuple[]',
      },
    ],
    name: 'positionPoolInfoLight',
    outputs: [
      {
        components: [
          {
            internalType: 'address',
            name: 'token0',
            type: 'address',
          },
          {
            internalType: 'address',
            name: 'token1',
            type: 'address',
          },
          {
            internalType: 'address',
            name: 'pool',
            type: 'address',
          },
          {
            internalType: 'uint128',
            name: 'liquidity',
            type: 'uint128',
          },
          {
            internalType: 'uint128',
            name: 'owed0',
            type: 'uint128',
          },
          {
            internalType: 'uint128',
            name: 'owed1',
            type: 'uint128',
          },
          {
            internalType: 'uint256',
            name: 'amount0',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'amount1',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'lowPrice',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'upPrice',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'currentPrice',
            type: 'uint256',
          },
          {
            internalType: 'bool',
            name: 'tickIn',
            type: 'bool',
          },
        ],
        internalType: 'struct IV3LiquidityHelper.PositionInfoLight[]',
        name: 'output',
        type: 'tuple[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
] as const;

export default abi;
